export default (node) => {
  let offsetTop = 0
  if (node.offsetParent) {
    do {
      offsetTop += node.offsetTop
    } while ((node = node.offsetParent))
  }

  return offsetTop
}
